import { useMemo } from 'react';
import { IChatConversation } from 'src/@types/chat';
import { useAuthContext } from 'src/auth/useAuthContext';
import { useWorkspaceParticipantsUsers } from 'src/hooks/useWorkspace';
import { ChannelAvatar } from '../../channel/ChannelAvatar';
import { P2PChannelAvatar } from '../../channel/P2PChannelAvatar';

export const ChatSelectorItemIcon = ({ chat }: { chat: IChatConversation }) => {
  const { user } = useAuthContext();
  const participants = useWorkspaceParticipantsUsers(chat?.participants || []);
  const users = useMemo(
    () => participants?.filter((i) => i._id !== user?._id),
    [participants, user?._id],
  );

  const otherUser = useMemo(() => users[0], [users]);
  return chat.p2p ? (
    <P2PChannelAvatar otherUser={otherUser} />
  ) : (
    <ChannelAvatar key={chat?._id} channel={chat} />
  );
};
